// Progressive enhancement of verified original charts in product descriptions.
// Without JavaScript the same images remain full-column; links also open the original.
(() => {
  if (window.bylluSizeChartZoom) return;
  window.bylluSizeChartZoom = true;
  const bg = document.documentElement.lang.toLowerCase().startsWith('bg');
  const labels = bg ? {
    title: 'Таблица с размери', zoom: 'Увеличи таблицата с размери', close: 'Затвори',
    hint: 'Увеличен изглед. Плъзни или превърти, за да видиш всички размери.',
  } : {
    title: 'Size chart', zoom: 'Enlarge size chart', close: 'Close',
    hint: 'Enlarged view. Swipe or scroll to see all sizes.',
  };
  const icon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><circle cx="10" cy="10" r="6.5"/><path d="m15 15 6 6M10 7v6M7 10h6"/></svg>';
  let dialog, viewport, enlarged, opener, previousOverflow, locked = false, loadVersion = 0;

  function restorePage() {
    if (!locked) return;
    locked = false;
    loadVersion++;
    document.body.style.overflow = previousOverflow;
    if (opener?.isConnected) opener.focus({ preventScroll: true });
  }

  function closeDialog() {
    dialog.close();
    restorePage();
  }

  function enhance(root = document) {
    root.querySelectorAll('.product-editorial-details img[data-product-size-chart]').forEach(img => {
      if (img.closest('a')) return;
      const link = document.createElement('a');
      link.className = 'product-size-chart-link';
      link.href = img.src;
      link.target = '_blank';
      link.rel = 'noopener';
      link.setAttribute('aria-label', labels.zoom);
      // If native dialogs are unavailable, the original image still opens normally.
      if (typeof HTMLDialogElement !== 'undefined' && HTMLDialogElement.prototype.showModal) {
        link.setAttribute('aria-haspopup', 'dialog');
      }
      const label = document.createElement('span');
      label.className = 'product-size-chart-link__label';
      label.innerHTML = icon;
      label.append(document.createTextNode(labels.zoom));
      img.before(link);
      link.append(img, label);
    });
  }

  function createDialog() {
    dialog = document.createElement('dialog');
    dialog.className = 'product-size-chart-dialog';
    dialog.setAttribute('aria-labelledby', 'ProductSizeChartTitle');
    dialog.setAttribute('aria-describedby', 'ProductSizeChartHint');
    dialog.innerHTML = '<header class="product-size-chart-dialog__header"><div><h2 id="ProductSizeChartTitle"></h2><p id="ProductSizeChartHint"></p></div><button type="button" class="product-size-chart-dialog__close" autofocus><span aria-hidden="true">×</span></button></header><div class="product-size-chart-dialog__viewport" tabindex="0" role="region"><img alt=""></div>';
    dialog.querySelector('h2').textContent = labels.title;
    dialog.querySelector('p').textContent = labels.hint;
    const close = dialog.querySelector('button');
    close.setAttribute('aria-label', labels.close);
    close.addEventListener('click', closeDialog);
    viewport = dialog.querySelector('.product-size-chart-dialog__viewport');
    viewport.setAttribute('aria-label', labels.title);
    dialog.addEventListener('keydown', event => {
      if (event.key !== 'Tab') return;
      if (event.shiftKey && document.activeElement === close) {
        event.preventDefault();
        viewport.focus({ preventScroll: true });
      } else if (!event.shiftKey && document.activeElement === viewport) {
        event.preventDefault();
        close.focus({ preventScroll: true });
      }
    });
    enlarged = viewport.querySelector('img');
    enlarged.alt = labels.title;
    let backdropDown = false;
    const outside = event => {
      const r = dialog.getBoundingClientRect();
      return event.target === dialog && (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom);
    };
    dialog.addEventListener('pointerdown', event => { backdropDown = outside(event); });
    dialog.addEventListener('click', event => {
      if (backdropDown && outside(event)) closeDialog();
      backdropDown = false;
    });
    dialog.addEventListener('cancel', event => { event.preventDefault(); closeDialog(); });
    dialog.addEventListener('close', () => { if (!dialog.open) restorePage(); });
    document.body.append(dialog);
  }

  document.addEventListener('click', async event => {
    const link = event.target.closest('.product-size-chart-link');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (typeof HTMLDialogElement === 'undefined' || !HTMLDialogElement.prototype.showModal) return;
    event.preventDefault();
    if (!dialog) createDialog();
    opener = link;
    const version = ++loadVersion;
    enlarged.src = link.href;
    previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    locked = true;
    dialog.showModal();
    enlarged.style.width = Math.min(1080, Math.max(720, viewport.clientWidth)) + 'px';
    try { await enlarged.decode(); } catch { /* Keep the original-image link as fallback. */ }
    if (version !== loadVersion || !dialog.open) return;
    enlarged.style.width = Math.min(enlarged.naturalWidth || 1080, Math.max(720, viewport.clientWidth)) + 'px';
    // These original square graphics have blank margins; centre vertically on the table.
    viewport.scrollTop = Math.max(0, (viewport.scrollHeight - viewport.clientHeight) / 2);
    viewport.scrollLeft = 0;
  });
  enhance();
  document.addEventListener('shopify:section:load', event => enhance(event.target));
})();
